import Constants from '@/constants';

/** Build a duplicate plan name, truncating the source so the result never exceeds MAX_PLAN_NAME_LENGTH. */
export const buildDuplicatePlanName = (
  sourceName: string,
  copyLabel: string,
  maxLength: number = Constants.FORMS.MAX_PLAN_NAME_LENGTH,
): string => {
  const suffix = ` ${copyLabel}`;
  const maxBaseLength = Math.max(0, maxLength - suffix.length);
  return sourceName.slice(0, maxBaseLength) + suffix;
};
